/*!
 *
 *  nav-current.js
 *
 */

const _ = require('underscore');

const NavActive = function( _this, options ){
	this.$wrap = $(_this);
	this.$a = this.$wrap.find('a');
	this.settings = {
		currentClass : 'current',
		abs: false,
		not: null
	};
	this.settings = $.extend({}, this.settings, options );
	this.init();
};

NavActive.prototype = {
	init: function(){
		const self = this;
		const URL = this.locate('path').replace(/index\.html/,'') + this.locate('search');
		const path = self.locate('path').split('/');
		const folder = _.initial(path, 1).join('/') + '/';

		this.$a.not( self.settings.not ).each(function(){
			const _href = $(this).attr('href').replace( self.locate('location') , '' ).replace(/index\.html/,'');
			let isCurrent = ( URL.search( _href ) == 0 );
			if( self.settings.abs ){
				isCurrent = ( URL == folder + _href || URL == _href );
			};
			if( isCurrent ){
				self.setCurrent( $(this) );
				if( $(this).closest('ul').closest('li').length ){
					self.setCurrent( $(this).closest('ul').closest('li').children('a') );
				};
			};
		});
	},
	setCurrent: function( $a ) {
		const _currentClass = $a.attr('class').split(' ')[0].replace(/(st-.+)(-.+)/g, '$1') + '-' + this.settings.currentClass;
		$a.addClass( _currentClass );
	},
	locate : function( _call ){
		if( !_call ) return false;
		switch( _call ){
			case 'path' :
				return location.pathname;
			case 'location' :
				return location.protocol + '//' + location.hostname;
			case 'domain' :
				return location.hostname;
			case 'protocol' :
				return location.protocol;
			case 'search' :
				return location.search;
		};
	}
};

module.exports = NavActive;


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/nav-current.js
// module id = 15
// module chunks = 0